function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round",
  strokeWidth: 4,
  transform: "translate(0 2)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#23C386",
  d: "M6.5 9.35h15.9"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  d: "M.5 9.35h6M.5 15.65h6"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#23C386",
  d: "M8.5 15.65h8.45"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18.5,
  cy: 12.5,
  r: 12,
  stroke: "#333"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  d: "M36.66 30.66l-9.69-9.69"
}));

function SvgResources(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39 35"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzOSAzNSI+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMikiPgogICAgPGxpbmUgeDE9IjYuNSIgeDI9IjIyLjQiIHkxPSI5LjM1IiB5Mj0iOS4zNSIgc3Ryb2tlPSIjMjNDMzg2Ii8+CiAgICA8bGluZSB4MT0iLjUiIHgyPSI2LjUiIHkxPSI5LjM1IiB5Mj0iOS4zNSIgc3Ryb2tlPSIjMzMzIi8+CiAgICA8bGluZSB4MT0iLjUiIHgyPSI2LjUiIHkxPSIxNS42NSIgeTI9IjE1LjY1IiBzdHJva2U9IiMzMzMiLz4KICAgIDxsaW5lIHgxPSI4LjUiIHgyPSIxNi45NSIgeTE9IjE1LjY1IiB5Mj0iMTUuNjUiIHN0cm9rZT0iIzIzQzM4NiIvPgogICAgPGNpcmNsZSBjeD0iMTguNSIgY3k9IjEyLjUiIHI9IjEyIiBzdHJva2U9IiMzMzMiLz4KICAgIDxsaW5lIHgxPSIzNi42NiIgeDI9IjI2Ljk3IiB5MT0iMzAuNjYiIHkyPSIyMC45NyIgc3Ryb2tlPSIjMzMzIi8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgResources as ReactComponent };